// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"15f5ba4006ace4ebf850","931":"7fc646a3c80b7f64195f"}[chunkId] + ".js";
};